export const NO_PENDING = Symbol('NO_PENDING')
